import { Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import db from "astrid-firebase/src/db";
import useLoadMore from "astrid-firestore/src/hooks/useLoadMore";

import LoadMore from "../../../../components/LoadMore/LoadMore";

import Table from "../../../tables/components/Table";

import useInvoiceTableColumns from "./hooks/useInvoicesTableColumns";

export default function InvoicesView({ header, firstPartyId }) {
	const { t } = useTranslation();

	const [invoices = [], loading, error, loadMore] = useLoadMore(
		firstPartyId &&
			db.collection("invoices").where("organization.id", "==", firstPartyId).orderBy("created", "desc"),
		{ limit: 30 },
	);

	const columns = useInvoiceTableColumns();

	return (
		<>
			<Header as="h3">{header}</Header>

			<Table data={invoices} columns={columns} />

			<LoadMore loading={loading} error={error} onClick={loadMore}>
				{t("showMore")}
			</LoadMore>
		</>
	);
}
